import { triggerLabel } from './automationBuilder';

const alphabetical = (left, right) => (left || '').localeCompare(right || '', undefined, { sensitivity: 'base', numeric: true });

export const automationTriggerTypes = (path) => [...new Set(path.triggerTypes || [])];

export const groupDashboardAutomations = (paths = [], { legacy = false, showDisabled = false, search = '' } = {}) => {
    const query = search.trim().toLowerCase();
    const groups = new Map();
    paths.filter(path => (path.schemaVersion !== 2) === legacy)
        .filter(path => showDisabled || path.isActive === true)
        .filter(path => !query || [
            path.name, path.description,
            ...automationTriggerTypes(path).map(triggerLabel),
        ].some(value => value?.toLowerCase().includes(query)))
        .sort((left, right) => alphabetical(left.name, right.name) || alphabetical(left.id, right.id))
        .forEach(path => {
            const types = automationTriggerTypes(path);
            // A legacy definition may have multiple triggers; keep it discoverable under each.
            (types.length ? types : ['UNCONFIGURED']).forEach(type => {
                if (!groups.has(type)) groups.set(type, {
                    key: type,
                    label: type === 'UNCONFIGURED' ? 'No trigger configured' : triggerLabel(type),
                    paths: [],
                });
                groups.get(type).paths.push(path);
            });
        });
    return [...groups.values()].sort((left, right) => alphabetical(left.label, right.label));
};
